<ng-container *ngLet="{
    shippingManagementEnabled: shippingManagementEnabled$ | async,
    shipTo: selectedShipTo$ | async,
    shipToCustomers: shipToCustomers$ | async,
    provinceList: provinceList$ | async,
    validateForm: validateForm$ | async,
    isShippingRatesLoading: isShippingRatesLoading$ | async,
    shippingRates: shippingRates$ | async,
    deliveryCosts: deliveryCosts$ | async,
    selectedShippingRate: selectedShippingRate$ | async,
    currencyCode: currencyCode$ | async,
    cartId: cartId$  | async,
    cashCustomerDefault: cashCustomerDefault$ | async
  } as vm">
  <ng-container *ngIf="!edit">
    <div id="checkout_div_AlternateShippingAddAddress" class="form-group d-flex align-items-center" *ngIf="!vm.shipTo && selectEnabled">
      <button id="checkout_button_AlternateShippingAddAddress"
        class="btn btn-primary btn-block text-start"
        type="button" (click)="load(vm.cashCustomerDefault, vm.shipToCustomers[0], vm.shipToCustomers.length > 1)"
        [disabled]="(loading$ | async) || disabled">
        <i class="fas fa-plus"></i> {{ vm.shipToCustomers.length <= 1 ? 'Add' : 'Select' }} shipping address
      </button>
      <span *ngIf="loading$ | async" class="countLoader"></span>
    </div>
    <div id="checkout_div_AlternateShippingAddressSelected" class="mb-2" *ngIf="vm.shipTo as account">
      <div id="checkout_div_AlternateShippingPreEditAlternateAddress" class="mb-3" *ngIf="vm.shipTo && !showDetails">
        Shipping to:<br/>
        <strong class="strong">{{account.customerName}}</strong><br/>
        <div>{{ account.streetAddress }}</div>
        <div>{{ account.city }}, {{ account.state }}, {{ account.postalCode }}</div>
        <div>{{ account.phoneNumber }}</div>
      </div>
    </div>
    <div class="form-editable p-4 mb-2" id="checkout_div_AlternateShippingPreEditAlternateAddressDetails" *ngIf="vm.shipTo && showDetails">
      <div class="d-flex align-items-top">
        <div class="col-6 mb-2">
            Your items will ship to the following location:<br/>
            <strong class="strong">{{vm.shipTo?.customerName}}</strong>
            <div>{{ vm.shipTo?.streetAddress }}</div>
            <div>{{ vm.shipTo?.city }}, {{ vm.shipTo?.state }}, {{ vm.shipTo?.postalCode }}</div>
            <div>{{ vm.shipTo?.phoneNumber }}</div>
            <div class="row form-editable p-4 mb-2" id="checkout_div_AlternateShippingPreEditAlternateAddressDetails" *ngIf="showDetails">
                <div class="d-flex mt-3 mb-3">
                  <div class="d-flex align-items-center">
                    <button id="checkout_a_AlternateShippingAddressSelected" class="btn hyperlink" type="button"
                      (click)="load(vm.cashCustomerDefault, vm.shipTo, vm.shipToCustomers.length > 1)"
                      [disabled]="(loading$ | async) || disabled">
                      Change shipping address
                    </button>
                    <span *ngIf="loading$ | async" class="countLoader"></span>
                  </div>
                  </div>
                  MSC Account # {{vm.shipTo?.mscAccountNumber}}<br/>
                  Salesperson # {{vm.shipTo?.salesperson || "Not available"}}<br/>
                  Address # {{ vm.shipTo?.addressNumber }}<br/>
            </div>
        </div>
        <ng-container *ngIf="vm.shippingManagementEnabled">
          <div style="margin-top: -10px;" class="col-6" *ngIf="vm.isShippingRatesLoading">
            Freight delivery options
            <i id="spinner" class="fas fa-spinner-third fa-fw fa-2x fa-spin"></i>
          </div>
          <div class="col-6" *ngIf="vm.shippingRates?.length && !vm.isShippingRatesLoading">
            <span class="mb-2">Freight delivery options:</span>
            <div class="form-group" [formGroup]="shipToForm" *ngFor="let shippingRate of vm.shippingRates; let i = index">
              <input id="freight_delivery_options_{{i}}" type="radio"
                [value]="shippingRate.service" [checked]="selectedShippingRate?.service === shippingRate.service"
                (click)="onFreightDeliveryOptionChange(shippingRate, vm.cartId);">
              <label for="freight_delivery_options_{{i}}" style="width: 100%;">
                <div class="ps-2">
                  <div class="row">
                    <div class="col-8">
                      <span>{{ shippingRate.description }}: </span><br/>
                      <span><i>Estimated delivery:</i></span>
                    </div>
                    <div class="col-4">
                      <div>{{ shippingRate.listRate | currency: vm.currencyCode :'symbol':'1.2-2' }} </div>
                      <div><i>{{ shippingRate.deliveryDate }}</i></div>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="edit">
    <form id="checkout_div_AlternateShippingEditAlternateAddress" [formGroup]="shipToForm" (ngSubmit)="update()" class="form-editable p-4 mb-2">
      <div class="form-group d-flex justify-content-between">
        <div>Address # {{ edit.addressNumber }}</div>
      </div>
      <div class="form-group">
        <input id="checkout_text_AlternateShippingName" type="text" class="form-control"
          placeholder="Name" formControlName="customerName">
      </div>
      <div class="form-group">
        <input id="checkout_text_AlternateShippingStreetAddress" type="text" class="form-control"
          placeholder="Street address" formControlName="streetAddress">
      </div>

      <div class="form-group">
        <div class="form-row">
          <div class="col">
            <input id="checkout_text_AlternateShippingCity" type="text" class="form-control"
              placeholder="City" formControlName="city">
          </div>
          <div class="col">
            <select id="checkout_select_AlternateShippingState" class="form-control"
              formControlName="state">
              <option value="">{{ isCanadaCustomer ? 'Province' : 'State' }}</option>
              <option *ngFor="let province of vm.provinceList; let i = index" [ngValue]="province.code">
                {{ province.name }}
              </option>
            </select>
          </div>

          <div class="col">
            <input id="checkout_text_AlternateShippingPostalCode" type="text" class="form-control"
              placeholder="Postal code" formControlName="postalCode">
          </div>
        </div>
      </div>

      <div class="form-group">
        <input id="checkout_text_AlternateShippingPhoneNumber" type="text" class="form-control"
          placeholder="Phone number" formControlName="phoneNumber">
      </div>
      <div class="form-group">
        <input id="checkout_text_AlternateShippingMSCAccountNumber" type="text" class="form-control"
          placeholder="MSC Account Number" formControlName="mscAccountNumber">
      </div>

        <div class="form-group">
          <b>Salesperson # {{edit.salesperson || "Not available"}}</b>
          <p class="text-danger">
            Your shipping address was updated for this order only.<br/>
            To make a permanent change to your shipping address, please contact Customer Support at 855-787-4223
          </p>
        </div>

        <div class="form-group gx-2">
          <button id="checkout_button_AlternateShippingDeliveryShipToShipDirectSubmit" type="submit"
            class="btn btn-primary" [disabled]="!shipToForm.valid || disabled">
            {{ inModal || (vm.shipTo && !isCashDefault) ? 'Update' : 'Add' }}
          </button>
          <button id="checkout_button_AlternateShippingCancel" class="btn hyperlink" type="button" (click)="cancel()">
            Cancel
          </button>
        </div>

    </form>
    <div *ngIf="!shipToForm.valid" class="alert alert-danger" id="shipTo-form-errors">
      <p *ngIf="shipToForm.errors['customerName.required']">Customer name is required.</p>
      <p *ngIf="shipToForm.errors['streetAddress.required']">Street address is required.</p>
      <p *ngIf="shipToForm.errors['city.required']">City is required.</p>
      <p *ngIf="shipToForm.errors['state.required']">{{isCanadaCustomer ? 'Province': 'State'}} is required.</p>
      <p *ngIf="shipToForm.errors['postalCode.required']">Postal code is required.</p>
      <p *ngIf="shipToForm.errors['phoneNumber.required']">Phone number is required.</p>
      <p *ngIf="shipToForm.errors['phoneNumber.pattern']">Enter a valid phone number.</p>
      <p *ngIf="shipToForm.errors['postalCode.pattern']">Enter a valid postal code.</p>
      <p *ngIf="shipToForm.errors['customerName.maxlength']">{{ errorMessages['customerName.maxlength'] }}</p>
      <p *ngIf="shipToForm.errors['streetAddress.maxlength']">{{ errorMessages['streetAddress.maxlength'] }}</p>
      <p *ngIf="shipToForm.controls.freightdeliveryoption?.errors?.required">Please select freight delivery option.</p>
    </div>
  </ng-container>
</ng-container>
